import { CheckCircle } from 'lucide-react';

const formatMoney = (v) => '$' + Math.abs(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ComparisonTable({ title, results }) {
  if (!results || results.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-300 mb-2">{title}</h3>
      <div className="bg-gray-800/30 border border-gray-800 rounded-xl overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="px-4 py-2 text-left text-[11px] text-gray-500 uppercase">Category</th>
              <th className="px-4 py-2 text-right text-[11px] text-gray-500 uppercase">QuickBooks</th>
              <th className="px-4 py-2 text-right text-[11px] text-gray-500 uppercase">FinBoard</th>
              <th className="px-4 py-2 text-right text-[11px] text-gray-500 uppercase">Variance</th>
            </tr>
          </thead>
          <tbody>
            {results.map(r => (
              <tr key={r.category} className="border-b border-gray-800/30">
                <td className="px-4 py-2 text-sm text-gray-200">
                  <span className={`inline-block w-1.5 h-1.5 rounded-full mr-2 ${r.match ? 'bg-emerald-400' : 'bg-red-400'}`} />
                  {r.category.replace(/_/g, ' ')}
                </td>
                <td className="px-4 py-2 text-right text-sm text-gray-300 font-mono">{formatMoney(r.qb_total)}</td>
                <td className="px-4 py-2 text-right text-sm text-gray-300 font-mono">{formatMoney(r.cube_total ?? r.duckdb_total)}</td>
                <td className={`px-4 py-2 text-right text-sm font-mono ${r.match ? 'text-emerald-400' : 'text-red-400'}`}>
                  {r.match ? '✓' : ''} {Object.is(r.variance, -0) || r.variance > 0 ? '+' : ''}{(Object.is(r.variance, -0) ? 0 : r.variance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
